import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import AppNavbar from './Component/Navbar/AppNavbar';
import Home from './Component/Home';
import AboutUsSection from './Component/About/AboutUsSection';
import OurServices from './Component/OurService/OurServices';
import CarRentalProcess from './Component/CarRentalProcess/CarRentalProcess';
import Enquiry from './Component/Enquiry/Enquiry';
import WeWorkWith from './Component/WeWorkWith/WeWorkWith';
import ServiceableCities from './Component/ServiceableCities/ServiceableCities';
import FloatingButtons from './Component/FloatingButtons/FloatingButtons';
import Footer from './Component/Footer/Footer';
// import HeroCarousel from './Component/HomeCarousel/HeroCarousel';
// import CarSlider from './Component/CarSlider/CarSlider';
// import Testimonials from './Component/Testimonials/Testimonials';

function App() {
  return (
    // <div className="App">
    //   <AppNavbar />
    //   <HeroCarousel />
    //   <AboutUsSection />
    //   <OurServices />
    //   <CarSlider />
    //   <ServiceableCities />
    //   <WeWorkWith />
    //   <Testimonials />
    //   <CarRentalProcess />
    //   <Enquiry />
    //   <FloatingButtons />
    //   <Footer />
    // </div>
      <div className="App">
        <Router>
          <AppNavbar />
          <Routes>
            <Route path="/" element={<Home/>} />
            <Route path="/about" element={<AboutUsSection />} />
            <Route path="/services" element={<OurServices />} />
            <Route path="/contact" element={<Enquiry />} />
            <Route path="/workwith" element={<WeWorkWith />} />
            <Route path="/cities" element={<ServiceableCities />} />
            <Route path="/process" element={<CarRentalProcess />} />
          </Routes>
          <FloatingButtons />
          <Footer />
        </Router>
      </div>
  );
}

export default App;